/* Copyright (c) 2021-2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { useShowError } from "~/components/Error/useShowError";
import { ClearButton } from "~/components/InlineEdit/ClearButton";
import { showSuccess } from "~/components/Toast";
import { Environment } from "~/models/environment";
import { useAxios, generateActionSuccessText } from "~/tools";

type EnvServiceLevelClearProps = {
  environment: Environment;
  refetch: () => Promise<void>;
};

export function EnvServiceLevelClear({
  environment,
  refetch,
}: EnvServiceLevelClearProps) {
  const { showError } = useShowError();
  const { Axios } = useAxios();

  const [isSubmittingLoading, setIsSubmittingLoading] = React.useState(false);

  const handleClear = async () => {
    setIsSubmittingLoading(true);
    const organizeValues = {
      ...environment,
      attachedServiceLevel: null,
    };
    try {
      await Axios().put(`/environments/${environment.id}`, organizeValues);
      refetch();
      showSuccess(generateActionSuccessText("Service Level")()("cleared")());
    } catch (e) {
      showError(e?.response);
    } finally {
      setIsSubmittingLoading(false);
    }
  };

  return <ClearButton onClick={handleClear} isLoading={isSubmittingLoading} />;
}
